import Controller from '@ember/controller';
import { PROJECT_CANCELLATION__QUERY_PARAMS } from "sh-www/constants/routes/project-cancellation";

class ProjectCancellationPaymentController extends Controller {
  queryParams = Object.values(PROJECT_CANCELLATION__QUERY_PARAMS);

  projectCancellationReason = null;
  additionalInformationNotes = null;
}

export default ProjectCancellationPaymentController;
